export const PHASE = {
    PREPARE: 0,
    WORK: 1,
    REST: 2,
    REST_BETWEEN: 3,
    END: 4,
    COOLDOWN: 5,
};

export const PHASE_LABEL = {
    [PHASE.PREPARE]: 'PREPARACIÓN',
    [PHASE.WORK]: 'GO',
    [PHASE.REST]: 'DESCANSO',
    [PHASE.REST_BETWEEN]: 'DESCANSO ENTRE TABATAS',
    [PHASE.END]: 'FIN',
    [PHASE.COOLDOWN]: 'ENFRIAMIENTO',
};

export const PHASE_CONFIG_KEYS = {
    [PHASE.PREPARE]: 'prepare',
    [PHASE.WORK]: 'work',
    [PHASE.REST]: 'rest',
    [PHASE.REST_BETWEEN]: 'restBetween',
    [PHASE.COOLDOWN]: 'cooldown',
};

// Category F: start sounds (work-start, rest-start, rest-between-start)
export const SOUND_START_FILES = [
    'boxstop',
    'boxstart',
    'bell2',
    'bell3',
    'bell4',
    'yougogirl',
    'shipsbell',
    'bell7',
    'belltinyshake',
    'boxingbell',
    'robotgo',
    'go2',
    'hit',
    'letsgo1',
    'letsgo2',
    'receptionbell',
    'cs_1',
    'cs_2',
    'cs3',
    'cs4',
    's5',
    's6',
    's7',
    's8',
    'sk14',
    's10',
    's11',
    's12',
    'sc16',
    'sc17',
    'sc27',
    'sc28',
    'newstart1',
    'newstart19',
    'newstart3',
    'newstart4',
    'newstart5',
    'newstart6',
    'newstart7',
    'newstart8',
    'newstart20',
    'newstart10',
    'newstart11',
    'newstart12',
    'newstart18',
    'newstart17',
    'newstart15',
    'newstart16',
    'nic',
];

// Category E: end of all workouts sounds
export const SOUND_END_FILES = [
    'fanfara3',
    'afiobsessionendrock',
    'davidbainendgamefail',
    'ramagochiviolinend',
    'speedenzaendoftheworldvoice',
    'k15',
    'k18',
    'k19',
    'k20',
    'fanfara',
    'k21',
    'k22',
    'k23',
    'k24',
    'k25',
    'k26',
    'sk14',
    'k13',
    'receptionbell',
    'sc27',
    'boxstop',
    'boxstart',
    'bell2',
    'bell3',
    'bell4',
    'boxingbell',
    'shipsbell',
    'bell7',
    'belltinyshake',
    's8',
    'sk14',
    's10',
    's11',
    's12',
    'sc16',
    'sc17',
    'sc27',
    'sc28',
    'newstart1',
    'newstart19',
    'newstart3',
    'newstart4',
    'newstart5',
    'newstart6',
    'newstart7',
    'newstart8',
    'newstart20',
    'newstart10',
    'newstart11',
    'newstart12',
    'newstart18',
    'newstart17',
    'newstart15',
    'newstart16',
    'nic',
];

// Category D: countdown sounds
export const SOUND_COUNTDOWN_FILES = [
    'tik3',
    'tik2',
    'tik',
    'cs_1',
    'cs_2',
    'cs3',
    'cs4',
    'sc16',
    'sc17',
    'sc27',
    'sc28',
    'newcount10',
    'newcount2',
    'newcount3',
    'newcount4',
    'newcount5',
    'newcount6',
    'newcount7',
    'newcount8',
    'newcount9',
    'nic',
];

export const DEFAULT_COLORS = {
    prepare: '#3B82F6',
    work: '#22C55E',
    rest: '#F59E0B',
    restBetween: '#F97316',
    cooldown: '#787878',
    tabata: '#AAAAAA',
};

export const DEFAULT_CONFIG = {
    prepare: 60,
    work: 20,
    rest: 20,
    restBetween: 60,
    cooldown: 60,
    rounds: 8,
    tabatas: 4,
    sounds: {
        work: 1,
        rest: 1,
        restBetween: 1,
        end: 1,
        countdown: 1,
    },
    volume: 100,
    colors: { ...DEFAULT_COLORS },
};

export const SOUND_CATEGORIES = {
    work: { label: 'Inicio de ejercicio', files: SOUND_START_FILES },
    rest: { label: 'Inicio de descanso', files: SOUND_START_FILES },
    restBetween: { label: 'Descanso entre tabatas', files: SOUND_START_FILES },
    end: { label: 'Fin de entrenamiento', files: SOUND_END_FILES },
    countdown: { label: 'Cuenta regresiva', files: SOUND_COUNTDOWN_FILES },
};

export function soundUrl(file) {
    return `/timer/sounds/${file}.mp3`;
}

export function volumeToGain(volume) {
    const v = Math.max(0, Math.min(100, volume));
    if (v >= 100) return 1;
    if (v <= 0) return 0;
    const gain = 1 - Math.log(100 - v) / Math.log(100);
    return Math.max(0, Math.min(1, gain));
}

export function formatTime(totalSeconds) {
    const s = Math.max(0, totalSeconds);
    const m = Math.floor(s / 60);
    const rem = s % 60;
    return `${m}:${String(rem).padStart(2, '0')}`;
}

export function formatTimeHms(totalSeconds) {
    const s = Math.max(0, totalSeconds);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const rem = s % 60;
    if (h > 0) {
        return `${h}:${String(m).padStart(2, '0')}:${String(rem).padStart(2, '0')}`;
    }
    return `${m}:${String(rem).padStart(2, '0')}`;
}

export function calculateTotalSeconds(config) {
    return (
        config.prepare +
        config.tabatas * config.rounds * config.work +
        config.tabatas * (config.rounds - 1) * config.rest +
        (config.tabatas - 1) * config.restBetween
    );
}

export function getSoundFile(category, index) {
    const files = SOUND_CATEGORIES[category]?.files ?? SOUND_START_FILES;
    const idx = Math.max(1, Math.min(files.length, index ?? 1));
    return files[idx - 1];
}

export function getSoundOptions(category) {
    const files = SOUND_CATEGORIES[category]?.files ?? SOUND_START_FILES;
    return files.map((file, i) => {
        const index = i + 1;
        return {
            index,
            label: file === 'nic' ? 'X' : `Sonido ${index}`,
            file,
        };
    });
}
